import { get } from "../../../api/axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL;

const loadFolderSummary = (documentId, siteId) => get(`${url}/leasingfolders/${documentId}/${siteId}/summary`);

const exp = {
  loadFolderSummary
};
export default exp;
